/// <amd-module name="SuiteCommerce.GiftCertificate.OptionTiles.Tile.CollectionView"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.OptionTiles.Tile.CollectionView", ["require", "exports", "Backbone.CollectionView", "SuiteCommerce.GiftCertificate.OptionTiles.Tile.View"], function (require, exports, BackboneCollectionView, OptionTiles_Tile_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TileCollectionView = void 0;
    var TileCollectionView = /** @class */ (function (_super) {
        __extends(TileCollectionView, _super);
        function TileCollectionView(options) {
            var _this = _super.call(this, options) || this;
            _this.childView = OptionTiles_Tile_View_1.TileView;
            return _this;
        }
        return TileCollectionView;
    }(BackboneCollectionView));
    exports.TileCollectionView = TileCollectionView;
});
